import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const BreadcrumbsList = styled.div`
	margin-right: auto;
	color: ${colors.grey8};
	z-index: 1;
	height: 100%;
	display: flex;
	align-items: center;
`;

export const BreadcrumbsListItem = styled.div`
	font-size: 16px;
	font-weight: 500;
	letter-spacing: 0.3px;
	cursor: pointer;
	color: ${colors.grey6};

	&:hover {
		color: ${colors.green2};
	}

	& + &:before {
		padding: 8px 3px 8px 5px;
		content: '/';
	}

	&:last-child {
		cursor: default;
		color: ${colors.grey8};

		&:hover {
			color: ${colors.grey8};
		}
	}

	${({ isLarge }) => isLarge && 'font-size: 19px;'};
`;
